








































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Map from '@/components/parts/Map.vue';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import CharacterIconPicker from '@/components/parts/CharacterIconPicker.vue';
import CountryColorPicker from '@/components/parts/CountryColorPicker.vue';
import AsyncUtil from '../../models/common/AsyncUtil';
import ArrayUtil from '../../models/common/arrayutil';
import Streaming from './../../api/streaming';
import ApiStreaming from './../../api/apistreaming';
import * as api from './../../api/api';
import * as def from '@/common/definitions';
import Enumerable from 'linq';
import NotificationService from '@/services/notificationservice';
import LoginService from '@/models/character/loginservice';
import ValueUtil from '@/models/common/ValueUtil';
import KmyChatTagText from '@/components/parts/KmyChatTagText.vue';

declare const grecaptcha: any;

@Component({
  components: {
    Map,
    CharacterIcon,
    CharacterIconPicker,
    CountryColorPicker,
    KmyChatTagText,
  },
})
export default class EntryPage extends Vue {
  private character: api.Character = new api.Character();
  private country: api.Country = new api.Country();
  private defaultCountry: api.Country = new api.Country();
  private town: api.Town = new api.Town();
  private password: string = '';
  private passwordConfirm: string = '';
  private icon: api.CharacterIcon = new api.CharacterIcon(0, 0, true, 1, '0.gif');
  private isPublish: boolean = false;
  private invitationCode: string = '';
  private isEditAttributes: boolean = false;
  private isOkEula: boolean = false;
  private isOkPrivacyPolicy: boolean = false;
  private isSelectedBeginner: boolean = false;
  private isCountryFree: boolean = false;
  private selectedSkills: def.CharacterSkillType[] = [];
  private selectedFormation: def.FormationType = def.FORMATION_TYPES[0];

  @Prop() private system!: api.SystemData;
  @Prop() private countries!: api.Country[];
  @Prop() private countryMessages!: api.CountryMessage[];
  private extraData: api.EntryExtraData = api.EntryExtraData.default;
  @Prop() private towns!: api.Town[];
  @Prop({
    default: true,
  }) private isOpened!: boolean;
  private nextMonthSeconds = 0;

  private isLoadingExtraData = true;
  private isLoadingExtraDataPrivate = true;
  private isEntrying = false;
  private isApp = false;

  private get canEntryAsBeginner(): boolean {
    return this.extraData.countryData.some((c) => !c.isJoinLimited && this.towns.some((t) => t.countryId === c.countryId));
  }

  private get formations(): def.FormationType[] {
    return def.FORMATION_TYPES.filter((f) => f.canGet);
  }

  private get sumOfAttributes(): number {
    return parseInt(this.character.strong.toString(), 10) +
      parseInt(this.character.intellect.toString(), 10) +
      parseInt(this.character.leadership.toString(), 10) +
      parseInt(this.character.popularity.toString(), 10);
  }

  private get isLoading(): boolean {
    return this.isLoadingExtraData || this.isEntrying;
  }

  private get isOkName(): boolean {
    return this.character.name !== '' && this.character.name.length >= 1 && this.character.name.length <= 12
      && !this.character.name.includes('_');
  }

  private get isOkAliasId(): boolean {
    return this.character.aliasId !== '' && this.character.aliasId.length >= 4 && this.character.aliasId.length <= 12;
  }

  private get isOkPassword(): boolean {
    return this.password !== '' && this.password.length >= 4 && this.password.length <= 12;
  }

  private get isOkPasswordConfirm(): boolean {
    return this.password === this.passwordConfirm && this.isOkPassword;
  }

  private get isOkIcon(): boolean {
    return true;
  }

  private get isOkTown(): boolean {
    if (this.isCountryFree) {
      return this.town.id !== 0;
    }

    if (this.town.id !== 0) {
      if (this.town.countryId) {
        const extraData = this.getExtraData(this.town.countryId);
        return !extraData.isJoinLimited;
      } else {
        return !this.character.isBeginner;
      }
    } else {
      return this.canBelongCountry;
    }
  }

  private get isTownSelected(): boolean {
    return this.town.id !== 0;
  }

  private get canBelongCountry(): boolean {
    return this.extraData.countryData.some((c) => !c.isJoinLimited);
  }

  private get isOkEstablishSelection(): boolean {
    if (this.isCountryFree) {
      return !this.isPublish;
    }

    return (!this.isTownSelected && !this.isPublish) ||
      (this.isTownSelected &&
       ((this.town.countryId !== 0 && !this.isPublish) ||
        (this.town.countryId === 0 && this.isPublish)));
  }

  private get isOkCountryName(): boolean {
    return !this.isPublish ||
      (this.country.name !== '' && this.country.name.length >= 1 && this.country.name.length <= 8 &&
       !Enumerable.from(this.countries).any((c) => c.name === this.country.name));
  }

  private get isOkCountryColor(): boolean {
    return !this.isPublish ||
      (this.country.colorId >= 1 && this.country.colorId <= def.COUNTRY_COLOR_NUM &&
       !Enumerable.from(this.countries).any((c) => c.colorId === this.country.colorId));
  }

  private get isOkCountryCivilization(): boolean {
    return !this.isPublish || this.country.civilization !== 0;
  }

  private get isFirstReligion(): boolean {
    return this.system.ruleSet === 2 || !this.countries.some((c) => c.religion === this.country.religion);
  }

  private get isOkFrom(): boolean {
    return this.character.from !== 0;
  }

  private get isOkFormation(): boolean {
    return this.character.formationType !== 0;
  }

  private get isOkStrong(): boolean {
    return this.character.strong >= 5 && this.character.strong <= this.extraData.attributeMax;
  }

  private get isOkIntellect(): boolean {
    return this.character.intellect >= 5 && this.character.intellect <= this.extraData.attributeMax;
  }

  private get isOkLeadership(): boolean {
    return this.character.leadership >= 5 && this.character.leadership <= this.extraData.attributeMax;
  }

  private get isOkPopularity(): boolean {
    return this.character.popularity >= 5 && this.character.popularity <= this.extraData.attributeMax;
  }

  private get isOkSumOfAttributes(): boolean {
    return this.sumOfAttributes === this.extraData.attributeSumMax;
  }

  private get isOkInvitationCode(): boolean {
    return !this.system.invitationCodeRequestedAtEntry ||
      this.invitationCode.length > 0;
  }

  private get isOkBeginner(): boolean {
    return this.isSelectedBeginner;
  }

  private get canEntry(): boolean {
    return this.isOkName &&
      this.isOkAliasId &&
      this.isOkPassword &&
      this.isOkPasswordConfirm &&
      this.isOkIcon &&
      this.isOkTown &&
      this.isOkEstablishSelection &&
      this.isOkCountryName &&
      this.isOkCountryColor &&
      this.isOkCountryCivilization &&
      this.isOkFrom &&
      this.isOkFormation &&
      this.isOkStrong &&
      this.isOkIntellect &&
      this.isOkLeadership &&
      this.isOkPopularity &&
      this.isOkSumOfAttributes &&
      this.isOkInvitationCode &&
      this.isOkEula &&
      this.isOkPrivacyPolicy &&
      this.isOkBeginner
      ;
  }

  public get townBuilding(): def.BuildingType {
    const result = Enumerable
      .from(def.TOWN_BUILDINGS)
      .firstOrDefault((b) => this.town.townBuilding === b.id);
    if (result) {
      return result;
    } else {
      return def.BuildingType.default;
    }
  }

  public get townType(): string {
    if (this.town.id > 0) {
      return def.TOWN_TYPES[this.town.type];
    }
    return '未選択';
  }

  public getReligionName(id: number): string {
    return def.RELIGION_TYPES[id];
  }

  @Watch('isOpened')
  public onIsOpenedChanged() {
    if (this.isOpened) {
      this.updateExtraData();
    }
  }

  private initializeRecaptcha() {
    // https://stackoverflow.com/questions/43890035/vue-js-google-recaptcha-callback
    setTimeout(() => {
      if (typeof grecaptcha === 'undefined') {
        this.initializeRecaptcha();
      } else {
        grecaptcha.render('recaptcha', {
          sitekey: 'SITE_KEY',
          size: 'invisible',
          badge: 'inline',
          // callback: self.submit,
        });
      }
    }, 100);
  }

  private getExtraData(countryId: number): api.CountryExtraData {
    const data = ArrayUtil.findUniquely(this.extraData.countryData, countryId, (ed) => ed.countryId);
    if (data) {
      return data;
    } else {
      return api.CountryExtraData.default;
    }
  }

  private getCountryMessage(country: api.Country): api.CountryMessage {
    const data = ArrayUtil.findUniquely(this.countryMessages, country.id, (cm) => cm.countryId);
    if (data) {
      return data;
    } else {
      return new api.CountryMessage();
    }
  }

  private getCountryPostName(post: number): string {
    return ValueUtil.getPostName(post);
  }

  private getCountryCivilizationType(id: number): def.CountryCivilizationType {
    const type = def.COUNTRY_CIVILIZATION_TYPES.find((t) => t.id === id);
    if (type) {
      return type;
    }
    return def.COUNTRY_CIVILIZATION_TYPES[0];
  }

  private created() {
    if ((window as any).sangokukmy_app) {
      this.isApp = true;
    }

    this.character.strong = 5;
    this.character.intellect = 5;
    this.character.leadership = 5;
    this.character.popularity = 5;

    // ストリーミングを開始
    ApiStreaming.top.on<api.SystemData>(api.SystemData.typeId, (log) => {
      this.updateExtraData(true);
    });
    ApiStreaming.top.on<api.MapLog>(api.MapLog.typeId, (log) => {
      if (log.eventType === 15 ||
          log.eventType === 16 ||
          log.eventType === 17 ||
          log.eventType === 18 ||
          log.eventType === 19 ||
          log.eventType === 20 ||
          log.eventType === 21 ||
          log.eventType === 22) {
        this.updateExtraData(true);
      }
    });

    this.updateExtraData();
  }

  private updateExtraData(isHidden: boolean = false) {
    if (!this.isOpened) {
      return;
    }

    if (this.isLoadingExtraData || (!this.isLoadingExtraDataPrivate && isHidden)) {
      if (!isHidden) {
        this.isLoadingExtraData = true;
      }
      this.isLoadingExtraDataPrivate = true;
      api.Api.getEntryExtraData()
        .then((data) => {
          this.extraData = data;
        })
        .catch(() => {
          NotificationService.entryExtraDataFailed.notify();
        })
        .finally(() => {
          if (!isHidden) {
            this.isLoadingExtraData = false;
          }
          this.isLoadingExtraDataPrivate = false;
        });
    }
  }

  private onTownChanged(id: number) {
    const t = ArrayUtil.find(this.towns, id);
    if (t) {
      this.town = t;
      this.character.townId = t.id;
    }
  }

  private onFromChanged(id: number) {
    this.character.from = id;

    let skillId = 0;
    let strong = 0;
    let intellect = 0;
    let leadership = 0;
    let popularity = 0;
    let primaries: number[] | undefined;

    if (id === api.CharacterSkill.typeStrong) {
      strong = 100;
      intellect = 5;
      leadership = 90;
      popularity = 5;
      primaries = [1, 3, 2, 4];
      skillId = 1;
    } else if (id === api.CharacterSkill.typeIntellect) {
      strong = 5;
      intellect = 100;
      leadership = 90;
      popularity = 5;
      primaries = [2, 3, 4, 1];
      skillId = 6;
    } else if (id === api.CharacterSkill.typeMerchant) {
      strong = 5;
      intellect = 100;
      leadership = 90;
      popularity = 5;
      primaries = [2, 3, 4, 1];
      skillId = 11;
    } else if (id === api.CharacterSkill.typeEngineer) {
      strong = 100;
      intellect = 5;
      leadership = 90;
      popularity = 5;
      primaries = [1, 3, 2, 4];
      skillId = 16;
    } else if (id === api.CharacterSkill.typeTerrorist) {
      strong = 100;
      intellect = 5;
      leadership = 90;
      popularity = 5;
      primaries = [1, 3, 2, 4];
      skillId = 26;
    } else if (id === api.CharacterSkill.typePeople) {
      strong = 5;
      intellect = 5;
      leadership = 90;
      popularity = 100;
      primaries = [4, 3, 2, 1];
      skillId = 31;
    } else if (id === api.CharacterSkill.typeTactician) {
      strong = 90;
      intellect = 5;
      leadership = 100;
      popularity = 5;
      primaries = [3, 1, 2, 4];
      skillId = 36;
    } else if (id === api.CharacterSkill.typeScholar) {
      strong = 5;
      intellect = 100;
      leadership = 90;
      popularity = 5;
      primaries = [2, 3, 4, 1];
      skillId = 41;
    } else if (id === api.CharacterSkill.typeStaff) {
      strong = 5;
      intellect = 100;
      leadership = 90;
      popularity = 5;
      primaries = [2, 3, 4, 1];
      skillId = 46;
    } else if (id === api.CharacterSkill.typeConfucianism) {
      strong = 5;
      intellect = 100;
      leadership = 90;
      popularity = 5;
      primaries = [2, 3, 4, 1];
      skillId = 58;
    } else if (id === api.CharacterSkill.typeTaoism) {
      strong = 5;
      intellect = 100;
      leadership = 90;
      popularity = 5;
      primaries = [2, 3, 4, 1];
      skillId = 63;
    } else if (id === api.CharacterSkill.typeBuddhism) {
      strong = 5;
      intellect = 100;
      leadership = 90;
      popularity = 5;
      primaries = [2, 3, 4, 1];
      skillId = 68;
    }

    if (!primaries) {
      return;
    }

    this.selectedSkills = this.getSkillItems(skillId);
    if (this.isEditAttributes) {
      return;
    }

    const sum = this.extraData.attributeSumMax;
    const max = this.extraData.attributeMax;

    let tip = sum - (strong + intellect + leadership + popularity);
    if (tip > 0) {
      primaries.forEach((p) => {
        if (tip > 0) {
          if (p === 1) {
            const val = Math.min(max - strong, tip);
            strong += val;
            tip -= val;
          } else if (p === 2) {
            const val = Math.min(max - intellect, tip);
            intellect += val;
            tip -= val;
          } else if (p === 3) {
            const val = Math.min(max - leadership, tip);
            leadership += val;
            tip -= val;
          } else if (p === 4) {
            const val = Math.min(max - popularity, tip);
            popularity += val;
            tip -= val;
          }
        }
      });
    }

    this.character.strong = strong;
    this.character.intellect = intellect;
    this.character.leadership = leadership;
    this.character.popularity = popularity;
  }

  private onFormationChanged(formation: def.FormationType) {
    this.character.formationType = formation.id;
    this.selectedFormation = formation;
  }

  private resetTown() {
    this.town = new api.Town();
    this.isCountryFree = false;
  }

  private getSkillItems(firstId: number): def.CharacterSkillType[] {
    const skills = [new api.CharacterSkill(0, firstId, 0, 0)];
    def.CHARACTER_SKILL_TYPES.filter((s) => {
      if (s.subjectAppear) {
        return s.subjectAppear(skills);
      }
      return true;
    }).forEach((s) => {
      this.getSkillItems(s.id).forEach((ss) => {
        if (!skills.some((sss) => sss.type === ss.id)) {
          skills.push(new api.CharacterSkill(0, ss.id, 0, 0));
        }
      });
    });
    return skills.map((s) => {
      return def.CHARACTER_SKILL_TYPES.filter((ss) => ss.id === s.type)[0];
    });
  }

  private entry() {
    if (this.canEntry || true) {
      this.isEntrying = true;
      if (!this.isTownSelected) {
        this.character.townId = 0;
        const countries = this.extraData.countryData.filter((c) => !c.isJoinLimited);
        const countryId = countries[Math.floor(Math.random() * countries.length)].countryId;
        const country = this.countries.find((c) => c.id === countryId);
        if (country) {
          const town = this.towns.find((t) => t.id === country.capitalTownId);
          if (town) {
            if (town.countryId === countryId) {
              this.character.townId = town.id;
              this.town = town;
            } else {
              const town2 = this.towns.find((t) => t.countryId === countryId);
              if (town2) {
                this.town = town2;
                this.character.townId = town2.id;
              }
            }
          }
        }
      }
      api.Api.entry(this.character,
                    this.icon,
                    this.password,
                    this.isPublish ? this.country : this.defaultCountry,
                    this.invitationCode,
                    this.isCountryFree)
        .then((auth) => {
          LoginService.setAccessToken(auth);
          if (this.character.isBeginner) {
            this.$router.push({ path: 'status', query: { first: '1' }});
          } else {
            this.$router.push('status');
          }
        })
        .catch((ex) => {
          if (ex.data.code === api.ErrorCode.duplicateCharacterNameOrAliasIdError) {
            NotificationService.entryFailedBecauseSameNameOrAliasId.notify();
          } else if (ex.data.code === api.ErrorCode.duplicateCountryNameOrColorError) {
            NotificationService.entryFailedBecauseSameCountryNameOrColor.notify();
          } else if (ex.data.code === api.ErrorCode.duplicateEntryError) {
            NotificationService.entryFailedBecauseSameIpAddress.notify();
          } else if (ex.data.code === api.ErrorCode.invitationCodeRequestedError) {
            NotificationService.entryFailedBecauseInvitationCode.notify();
          } else if (ex.data.code === api.ErrorCode.invalidSecretKeyError) {
            NotificationService.entryFailedBecauseInvalidSecretKey.notify();
          } else {
            NotificationService.entryFailed.notify();
          }
        })
        .finally(() => {
          this.isEntrying = false;
        });
    }
  }
}
